import { MessageCircle, FileText, Compass } from "lucide-react";
import { useSite } from "@/context/SiteContext";
import { Reveal } from "@/components/Reveal";

export default function CTASection() {
  const { openQuote, waLink } = useSite();
  return (
    <section className="relative py-20 sm:py-28 px-4 sm:px-6 lg:px-8 overflow-hidden">
      <div className="absolute inset-0 bg-gradient-to-b from-[#04261C] to-[#060B11]" />
      <div className="grain absolute inset-0" />
      <Reveal className="relative max-w-4xl mx-auto text-center">
        <div className="mono-label">Need Help Choosing?</div>
        <h2 className="font-display text-3xl sm:text-4xl lg:text-5xl font-extrabold text-white mt-3 leading-tight">
          Need Help Choosing the Right <span className="text-gradient">Energy Solution?</span>
        </h2>
        <p className="text-slate-300 mt-5 max-w-2xl mx-auto text-base sm:text-lg leading-relaxed">
          Tell us your requirement, load and application. Our team will help you select the right combination of solar, inverter, battery and power backup solutions.
        </p>
        <div className="flex flex-wrap gap-3 justify-center mt-8">
          <button onClick={() => openQuote("CTA Section")} className="btn-primary" data-testid="cta-find-solution"><Compass size={18} /> Find Your Energy Solution</button>
          <button onClick={() => openQuote("CTA Section")} className="btn-ghost" data-testid="cta-get-quote"><FileText size={18} /> Get a Quote</button>
          <a href={waLink()} target="_blank" rel="noreferrer" className="btn-ghost" data-testid="cta-whatsapp"><MessageCircle size={18} /> WhatsApp Us</a>
        </div>
      </Reveal>
    </section>
  );
}
